var HtmlComponent_default = {
  "htmlComponent": "Eakxg",
  "htmlComponent_placeholder": "Fye8G"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
